import { captchaManager } from './CaptchaManager';

type MiddlewareFn = (headers?: Headers) => Promise<Response>;

export async function captchaMiddleware(next: MiddlewareFn, url: string, headers?: Headers): Promise<Response> {
  const token = await captchaManager.getTokenForRequest(url);

  if (token) {
    const newHeaders = new Headers(headers || {});
    newHeaders.set('App-Recaptcha-Token', token);
    return next(newHeaders);
  }

  return next(headers);
}
